export const GET_STATISTICS = "GET_STATISTICS";
export const SET_STATISTICS = "SET_STATISTICS";
export const RESET_STATISTICS = "RESET_STATISTICS";
export const SET_STATISTICS_FORM = "SET_STATISTICS_FORM";
export const GET_STATISTICS_CSV_FILE = "GET_STATISTICS_CSV_FILE";

export const resetStatistics = () => ({
  type: RESET_STATISTICS,
});

export const getStatistics = () => ({
  type: GET_STATISTICS,
});

export const setStatistics = (statistics: any) => ({
  type: SET_STATISTICS,
  statistics,
});

export const setStatisticsForm = (statisticsForm: any) => ({
  type: SET_STATISTICS_FORM,
  statisticsForm,
});

const initialState = {};

export const statisticsReducer = (state = initialState, action: any) => {
  const { statistics } = action;
  const { params } = action;
  switch (action.type) {
    case SET_STATISTICS_FORM:
      return { ...state, params };

    case SET_STATISTICS:
      return { ...state, statistics };
    case RESET_STATISTICS:
      return initialState;
    default:
      return state;
  }
};
